import React from "react";
import VerifyEmailLayer from "../components/VerifyEmailLayer";

const VerifyEmailPage = () => {
  return <VerifyEmailLayer />;
};

export default VerifyEmailPage;